import { type GatsbyLinkProps, Link } from 'gatsby'
import { LocalizedLink } from '../v2/LocalizedLink'

type UiLinkProps = React.PropsWithoutRef<GatsbyLinkProps<{}>> & {
  to: string
  children: React.ReactNode
}

const UiLink = ({ to, children, ...rest }: UiLinkProps) => (
  <LocalizedLink to={to} {...rest}>
    {children}
  </LocalizedLink>
)

export default UiLink
